/**
 * Utilities for working with local local storage
 */

import LocalStorageConfig from '../config/localStorage';

class LocalStorageUtils {
  /**
   * Sets a local storage value using a key value pair.
   * @param {string} key
   * @param {string} value
   * @returns {mixed} type
   */
  static setLocalStorageValue(key, value) {
    try {
      if (localStorage) {
        localStorage.setItem(key, value);
      }
    } catch (e) {
      console.log('Could not set LocalStorage value.');
    }
  }

  /**
   * Gets a local storage value using a key
   * @param {string} key
   * @returns {mixed} type
   */
  static getLocalStorageValue(key) {
    try {
      if (localStorage) {
        return localStorage.getItem(key);
      }
      return null;
    } catch (e) {
      console.log('Could not get LocalStorage value.');
      throw e;
    }
  }

  /**
   * Determines if the timestamp for the user's last search has expired
   * @returns {boolean}
   */
  static hasSearchedFlagExpired() {
    try {
      let hasSearchedFlagExpired = false;

      if (localStorage) {
        let hasSearchedFlagDate = localStorage.getItem(LocalStorageConfig.lastSearchedTimestamp);

        if (hasSearchedFlagDate) {
          hasSearchedFlagDate = parseInt(hasSearchedFlagDate, 10);
          const hasSearchedFlagExpirationDate = hasSearchedFlagDate + (LocalStorageConfig.searchFlagExpiration * 1000 * 60);

          if (hasSearchedFlagDate && hasSearchedFlagExpirationDate < Date.now()) {
            hasSearchedFlagExpired = true;
          }
        }
      }

      return hasSearchedFlagExpired;
    } catch (e) {
      console.log('Could not parse search flag date.');
      return false;
    }
  }

  static isHasSearchedFlagSet() {
    try {
      let hasSearchedFlag = false;

      if (localStorage) {
        hasSearchedFlag = localStorage.getItem(LocalStorageConfig.hasSearchedFlag);

        if (hasSearchedFlag === 'true') {
          hasSearchedFlag = true;
        } else {
          hasSearchedFlag = false;
        }
      }

      return hasSearchedFlag;
    } catch (e) {
      console.log('Could not parse search flag.');
      return false;
    }
  }

  static setLocalStorageObject(key = false, val = {}) {
    try {
      if (Object.keys(val).length > 0 && key) {
        this.setLocalStorageValue(key, JSON.stringify(val));
      }
    } catch (e) {
      console.log('Could not set LocalStorage object.');
    }
  }

  static getLocalStorageObject(key = false) {
    try {
      if (key) {
        return JSON.parse(this.getLocalStorageValue(key));
      }

      return null;
    } catch (e) {
      console.log('Could not get LocalStorage object.');
      throw e;
    }
  }
}

export default LocalStorageUtils;
